module.exports = __webpack_public_path__ + "img/icon-setting.a893579d.svg";